/* eslint-disable no-unused-vars */
/* eslint-disable sonarjs/no-duplicate-string */
import { getAPIConfig } from '@tcp/core/src/utils';
import { executeExternalAPICall, executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';
import { getFormattedError } from '../../../utils/errorMessage.util';
import CONSTANTS from '../../../components/common/organisms/AdyenPayment/views/AdyenPayment.constants';

const responseHandler = (res) => {
  return res.body.data;
};

const responseHandlerPayments = (res) => {
  return res.body;
};

const identifier = new Date().getMilliseconds();

const paymentsConfig = {
  origin: 'https://local.childrensplace.com:3000/bag/',
  returnUrl: '',
  reference: `${identifier}-checkout-components-ref`,
  authenticationData: {
    attemptAuthentication: 'always',
    threeDSRequestData: {
      nativeThreeDS: 'preferred',
    },
  },
  shopperEmail: 'test-shopper@storytel.com',
  shopperIP: '172.30.0.1',
  channel: 'Web',
  browserInfo: {
    acceptHeader: 'http',
  },
  lineItems: [
    {
      taxPercentage: 0,
      id: 'item1',
      taxAmount: 0,
      description: 'Test Item 1',
      amountIncludingTax: 75900,
      quantity: 1,
      taxCategory: 'None',
      amountExcludingTax: 75900,
    },
    {
      taxPercentage: 0,
      id: 'item2',
      taxAmount: 0,
      description: 'Test Item 2',
      amountIncludingTax: 10000,
      quantity: 1,
      taxCategory: 'None',
      amountExcludingTax: 10000,
    },
  ],
};

export const DEFAULT_SHOPPER_REFERENCE = 'jonny-jansen';

const makeSessionsSetupCall = (isBagPage, errorMapping) => {
  const fromPage = isBagPage ? 'CART_PAGE' : 'CHECKOUT_PAGE';

  const webService = endpoints.adyenSessions;
  const fullRequest = {
    redirectUrl: fromPage,
  };

  const payload = {
    body: JSON.stringify(fullRequest),
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    webService: {
      ...webService,
    },
  };

  return executeStatefulAPICall(payload)
    .then((res) => responseHandler(res))
    .catch((err) => {
      throw getFormattedError(err, errorMapping);
    });
};

export function makePaymentsCall(data, isBagPage) {
  const fromPage = isBagPage ? 'CART_PAGE' : 'CHECKOUT_PAGE';

  const { type, subtype } = data?.paymentMethod;
  const paymentsRequest = {
    paymentMethod: {
      type,
      subtype,
    },
    returnUrl: fromPage,
  };

  const webService = endpoints.adyenPayments;

  const payload = {
    body: JSON.stringify(paymentsRequest),
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    webService: {
      ...webService,
    },
  };
  return executeStatefulAPICall(payload)
    .then((res) => responseHandler(res))
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export function updatePayPalOrder({
  sessionId,
  pspReference,
  paymentData,
  amount,
  deliveryMethods,
  shippingAddress,
}) {
  const paymentsRequest = {
    paymentData,
    pspReference,
    shippingAddress,
  };

  const webService = endpoints.adyenUpdatePaypalOrder;

  const payload = {
    body: paymentsRequest,
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    webService: {
      ...webService,
    },
  };
  return executeStatefulAPICall(payload)
    .then((res) => responseHandlerPayments(res))
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export default makeSessionsSetupCall;
